import { api } from '@/lib/api';
import { PhotoData, GeoLookupResponse } from '@/types';

export class PhotoService {
  static async getAll(): Promise<PhotoData[]> {
    const response = await api.get<PhotoData[]>('/photos');
    return response.data;
  }

  static async getById(id: string): Promise<PhotoData> {
    const response = await api.get<PhotoData>(`/photos/${id}`);
    return response.data;
  }

  static async create(photoData: FormData): Promise<PhotoData> {
    const response = await api.post<PhotoData>('/photos', photoData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  static async update(id: string, updates: FormData): Promise<PhotoData> {
    const response = await api.put<PhotoData>(`/photos/${id}`, updates, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  static async archive(id: string): Promise<void> {
    await api.post(`/photos/${id}/archive`);
  }

  static async delete(id: string): Promise<void> {
    await api.delete(`/photos/${id}`);
  }

  static async lookupLocation(lat: number, lng: number): Promise<GeoLookupResponse> {
    const response = await api.get<GeoLookupResponse>('/lookup', { params: { lat, lng } });
    return response.data;
  }
}
